import React from 'react';
import MobilePopup from '../../../component/newPopup/mobilePopup/MobilePopup';
import * as css from './TableDetailsPop.css';

export interface DetailItem {
    label: string;
    value: string | number | React.ReactNode;
}

export interface TableDetailsPopProps {
    title: string;
    subtitle?: React.ReactNode;
    image?: string;
    details: DetailItem[];
    headerActions?: React.ReactNode;
    actions?: React.ReactNode;
    show: {showClass: string; isOpen: boolean};
    onClose: () => void;
    dataCyName?: string;
}

export default function TableDetailsPop({title, subtitle, image, details, headerActions, actions, show, onClose, dataCyName = 'tableDetails'}: TableDetailsPopProps) {    
    // Create a wrapper component for headerActions to use with list prop
    const HeaderActionsComponent = headerActions ? () => (
        <css.headerActions>
            {headerActions}
        </css.headerActions>
    ) : null;
    
    return (
        <css.popupWrapper rowImage={image}>
            <MobilePopup 
                showClass={show.showClass} 
                close={onClose} 
                title={undefined} 
                dataCyName={dataCyName} 
                height="auto" 
                list={HeaderActionsComponent ? {comp: HeaderActionsComponent} : undefined} 
                forwardRef={undefined}
            >
                <css.container>
                    {subtitle && subtitle}
                    <css.title>{title}</css.title>
                    <css.detailsGrid>
                        {details.map((detail, index) => {
                            const value = detail.value;
                            return (
                                <css.detailItem key={index}>
                                    <css.label>{detail.label}</css.label>
                                    <css.value>{value || '-'}</css.value>
                                </css.detailItem>
                            );
                        })}
                    </css.detailsGrid>
                    {actions && (
                        <css.actionsSection>
                            {actions}
                        </css.actionsSection>
                    )}
                </css.container>
            </MobilePopup>
        </css.popupWrapper>
    );
}

